<template>
  <div class="remark-wrap">
    <button class="btn square" @click.stop="openHandler">
      <v-icon>message</v-icon>
    </button>
    <div class="remark-dialog-wrap" v-if="isModalOpen" @click.stop="">
      <div class="remark-dialog block">
        <h3 class="pa-5 text-left">{{ peopleName }}-備註</h3>
        <div class="px-5">
          <textarea
            placeholder="請輸入備註"
            class="h-100px"
            v-model="tempRemarks"
          ></textarea>
        </div>
        <div class="pa-5 text-right">
          <button class="btn w-100px mr-10px" @click.stop="cancelHandler">
            取消
          </button>
          <button class="btn btn-primary w-100px" @click.stop="saveHandler">
            儲存
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    peopleName: {
      type: String,
      default: '應徵者姓名',
    },
    parentRemarks: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isModalOpen: false,
      tempRemarks: '',
    };
  },
  methods: {
    openHandler() {
      this.tempRemarks = this.parentRemarks;
      this.isModalOpen = true;
    },
    cancelHandler() {
      this.isModalOpen = false;
    },
    saveHandler() {
      this.$emit('save-remarks', this.tempRemarks);
      this.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.remark-wrap {
  width: 40px;
  height: 40px;
}

.remark-dialog-wrap {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(209, 208, 208, 0.5);
  z-index: 100;
  cursor: default;
}
.remark-dialog {
  width: 720px;
  margin: 0 auto;
  margin-top: 288px;
}
</style>
